import { render } from "./InstallBanner.vue?vue&type=template&id=0653d239&scoped=true"
import script from "./InstallBanner.vue?vue&type=script&lang=js"
export * from "./InstallBanner.vue?vue&type=script&lang=js"

import "./InstallBanner.vue?vue&type=style&index=0&id=0653d239&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aiden\\OneDrive - Qismat\\Development\\brydg-bdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0653d239"]])

export default __exports__